import { createFileRoute, redirect } from '@tanstack/react-router';

/**
 * Back-compat redirect (#4659). Google campaign URLs moved from ``/campaigns/<slug>`` to
 * ``/campaigns/google/<slug>`` to standardise on a platform-prefixed structure (the Meta sibling is
 * ``/campaigns/meta/<slug>``). Google campaigns are live in production, so bookmarks, digest-email
 * links, and shared URLs still point at the old path — this route catches them and forwards to the
 * new one with the slug preserved, so nothing in the wild 404s.
 *
 * The static ``google/`` and ``meta/`` segments take routing priority over this dynamic ``$campaignslug``,
 * so only genuinely-old ``/campaigns/<slug>`` links land here.
 */
export const Route = createFileRoute('/_authenticated/_layout/campaigns/$campaignslug')({
  beforeLoad: ({ params }) => {
    throw redirect({
      to: '/campaigns/google/$campaignslug',
      params: { campaignslug: params.campaignslug },
      replace: true,
    });
  },
});
